<template>
  <div>
    <div class="l-container">

      <div style="display: flex; align-items: center; padding: 5px 0">
        <h1 class="m-name">[{{family.id}}] {{family.f_name}} {{family.l_name}}({{family.f_name_kana}} {{family.l_name_kana}}) 様</h1>

        <transition name="loading" mode="out-in">
          <template v-if="family.appointments">

            <template v-if="family.appointments.length > 0">
              <router-link :to="{ name: 'appointmentindex', params: { id: family.appointments[0].id }, exact: true }"> <!--appointments.length 分回したい-->
                <i class="fa fa-car"></i>
              </router-link>
            </template>

          </template>
        </transition>

        <div class="mediumForm">

          <ul>
            <li class="medium-list" v-for="(list, index) in family.students" :key="index.id">
              <span v-if="list.state === 0"></span>
              <span v-if="list.state === 1">指導中</span>
              <span v-if="list.state === 2">休止</span>
              <span v-if="list.state === 3">CXL</span>
              <span v-if="list.state === 4">終了</span>
            </li>
          </ul>

        </div>

      </div>

      <section-navi>
        <section-item>
          <router-link :to="{ name: 'familyindex', params: { id: family.id }, exact: true }" exact>データ</router-link>
        </section-item>
        <section-item @click.native="getGeo">
          <router-link :to="{ name: 'familymap', params: { id: family.id }, exact: true }">地図</router-link>
        </section-item>
        <section-item>
          <router-link :to="{ name: 'familyappointmentview', params: { id: family.id }, exact: true }">AP情報</router-link>
        </section-item>
        <section-item>
          <router-link :to="{ name: 'familyhistory', params: { id: family.id }, exact: true }">対応履歴</router-link>
        </section-item>
        <section-item>
          <router-link :to="{ name: 'familyfileview', params: { id: family.id }, exact: true }">家庭ファイル</router-link>
        </section-item>
        <section-item>
          <family-gmail-support :family="family"></family-gmail-support>
        </section-item>
        <!-- <section&#45;item> -->
        <!--   <router&#45;link :to="{ name: 'familyagreements', params: { id: student.id }, exact: true }">契約内容</router&#45;link> -->
        <!-- </section&#45;item> -->
      </section-navi>
      <router-view :family="family" :condition="condition" :edit_id="edit_id"></router-view>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  data () {
    return {
      edit_id: {
        family_id: '',
        list_id: ''
      },
      condition: {
        condition: false
      },

      // getGeo用
      pref: [
        { name: '未選択', value: 0 },
        { name: '北海道', value: 1 },
        { name: '青森県', value: 2 },
        { name: '秋田県', value: 3 },
        { name: '岩手県', value: 4 },
        { name: '山形県', value: 5 },
        { name: '宮城県', value: 6 },
        { name: '福島県', value: 7 },
        { name: '栃木県', value: 8 },
        { name: '山梨県', value: 9 },
        { name: '群馬県', value: 10 },
        { name: '茨城県', value: 11 },
        { name: '千葉県', value: 12 },
        { name: '埼玉県', value: 13 },
        { name: '東京都', value: 14 },
        { name: '神奈川県', value: 15 },
        { name: '静岡県', value: 16 },
        { name: '長野県', value: 17 },
        { name: '愛知県', value: 18 },
        { name: '岐阜県', value: 19 },
        { name: '新潟県', value: 20 },
        { name: '富山県', value: 21 },
        { name: '石川県', value: 22 },
        { name: '福井県', value: 23 },
        { name: '滋賀県', value: 24 },
        { name: '京都府', value: 25 },
        { name: '三重県', value: 26 },
        { name: '和歌山県', value: 27 },
        { name: '奈良県', value: 28 },
        { name: '大阪府', value: 29 },
        { name: '兵庫県', value: 30 },
        { name: '鳥取県', value: 31 },
        { name: '島根県', value: 32 },
        { name: '岡山県', value: 33 },
        { name: '広島県', value: 34 },
        { name: '山口県', value: 35 },
        { name: '高知県', value: 36 },
        { name: '徳島県', value: 37 },
        { name: '香川県', value: 38 },
        { name: '愛媛県', value: 39 },
        { name: '福岡県', value: 40 },
        { name: '佐賀県', value: 41 },
        { name: '長崎県', value: 42 },
        { name: '熊本県', value: 43 },
        { name: '宮崎県', value: 44 },
        { name: '大分県', value: 45 },
        { name: '鹿児島県', value: 46 },
        { name: '沖縄県', value: 47 }
      ]
    }
  },
  computed: {
    family () {
      return this.$store.getters.family
    }
  },
  methods: {
    getGeo () {
      this.$store.dispatch('getGeo', {
        this: this,
        family: this.family,
        pref: this.pref
      })
    },

    getFamily (id) {
      // console.log(this.family)
      Vue.delete(this.family, 'familysupports')
      Vue.delete(this.family, 'students')
      Vue.delete(this.family, 'appointments')
      this.$store.dispatch('getFamily', id)
    },

    getTags () {
      this.$store.dispatch('getTags')
    },

    getCompanies () {
      this.$store.dispatch('getCompanies')
    },

    getOffices () {
      this.$store.dispatch('getOffices')
    },

    getPrefs () {
      this.$store.dispatch('getPrefs')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getFamily(to.params.id)
      vm.getTags(to)
      vm.getCompanies(to)
      vm.getOffices(to)
      vm.getPrefs(to)
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang='scss'>
.fade-leave-active {
  transition: opacity 0s;
  opacity: 0;
}
.fade-enter-active /* .fade-leave-active below version 2.1.8 */ {
  transition: opacity .3s;
}

.l-container {
  .home {
    cursor: pointer;
    &:hover {
      opacity: 0.5;
    }
  }
  .fa-user-circle, .fa-graduation-cap {
    font-size: 50px;
    margin: 0 3px;
  }
  .fa-car, .fa-home, {
    font-size: 30px;
  }
  .man {
    color: #3F51B5;
  }
  .woman {
    color: #E91E63;
  }
}
.m-name {
  padding-left: 10px;
  padding-right: 10px;
  white-space: nowrap;
}
.fa {
  cursor: pointer;
}
.tagInput {
  display: flex;
  border-radius: 15px;
  height: 42px;
}
</style>
<style lang="scss" scoped>
.mediumForm {
  /* font-size: 1rem; */
  display: flex;
  align-items: center;
  ul {
    margin: 0;
    display: flex;
    white-space: nowrap;
    .medium-list {
      display: flex;
      list-style: none;
      margin-left: 5px;
      background: #41B883;
      color: #fff;
      border-radius: 20px;
      span {
        padding: 10px;
        width: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Family.vue?69646051